export const DRIVE_TARGET_FOLDER_KEY = 'omakase-unshi:drive-target-folder';

export interface DriveTargetFolder {
  id: string;
  name: string;
}

export function getSavedFolderTarget(): DriveTargetFolder | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(DRIVE_TARGET_FOLDER_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<DriveTargetFolder>;
    if (typeof parsed.id !== 'string' || typeof parsed.name !== 'string') return null;
    return { id: parsed.id, name: parsed.name };
  } catch {
    return null;
  }
}

export function setSavedFolderTarget(target: DriveTargetFolder): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(DRIVE_TARGET_FOLDER_KEY, JSON.stringify(target));
}

export function clearSavedFolderTarget(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(DRIVE_TARGET_FOLDER_KEY);
}
